import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M572.501333,747 L317.568,1562.89333 L215.701333,1531.10667 L494.208,640.333333 L1600.02133,640.333333 L1600.02133,320.333333 L783.808,320.333333 L612.181333,107 L0.0213333333,107 L0.0213333333,1653.66667 C0.0213333333,1741.88 71.808,1813.66667 160.021333,1813.66667 L1548.07467,1813.66667 C1624.02133,1813.66667 1690.048,1759.58667 1704.98133,1685.02667 L1892.608,747 L572.501333,747 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconOpenFolderSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconOpenFolderSolid, _Component);

  var _super = _createSuper(IconOpenFolderSolid);

  function IconOpenFolderSolid() {
    _classCallCheck(this, IconOpenFolderSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconOpenFolderSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconOpenFolder",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconOpenFolderSolid.displayName = "IconOpenFolderSolid";
  return IconOpenFolderSolid;
}(Component);

IconOpenFolderSolid.glyphName = 'open-folder';
IconOpenFolderSolid.variant = 'Solid';
IconOpenFolderSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconOpenFolderSolid;
export { IconOpenFolderSolid };